import { Link, useLocation } from 'react-router-dom';

export default function Sidebar({ children, navLinks }) {
    const location = useLocation();
    const currentPath = location.pathname;
    const getNavLinkClass = (path) =>
        currentPath === path || currentPath.startsWith(`${path}/`) ? 'usa-current' : undefined;

    return (
        <div className="app-content">
            <aside className="app-sidebar" aria-label="Primary">
                <nav>
                    <ul className="usa-sidenav">
                        {
                            navLinks.map(({ label, path }) => (
                                <li key={path} className="usa-sidenav__item">
                                    <Link to={path} className={getNavLinkClass(path)}>
                                        {label}
                                    </Link>
                                </li>
                            ))
                        }
                    </ul>
                </nav>
            </aside>
            <div className="app-page">{children}</div>
        </div>
    );
};
